import { render, staticRenderFns } from "./ApprovalRewardsModal.vue?vue&type=template&id=4805573b&"
import script from "./ApprovalRewardsModal.vue?vue&type=script&lang=js&"
export * from "./ApprovalRewardsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports